import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import PageTitle from '../controls/PageTitle'
import * as AutomationActionCreators from '../../actions/automation'
import AutomationListView from './AutomationListView'

class UnitAutomationsListPage extends React.Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    automations: PropTypes.object.isRequired,
    automationsByUnit: PropTypes.object.isRequired,
    automationActions: PropTypes.object.isRequired,
  }

  static mapStateToProps(state) {
    return {
      automations: state.automations,
      automationsByUnit: state.automationsByUnit,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      automationActions: bindActionCreators(AutomationActionCreators, dispatch),
    }
  }

  componentDidMount() {
    const { automationActions } = this.props
    automationActions.listUnitAutomations(this.unitId())
  }

  onAddAutomation = (automation) => {
    const { automationActions } = this.props
    automationActions.addUnitAutomation(this.unitId(), automation)
  }

  onSaveAutomation = (automation) => {
    const { automationActions } = this.props
    automationActions.saveAutomation(automation)
  }

  onDeleteAutomation = (id) => {
    const { automationActions } = this.props
    automationActions.removeUnitAutomation(this.unitId(), id)
  }

  unitId() {
    return parseInt(this.props.match.params.unitId, 10)
  }

  unitAutomation() {
    const {
      automations, automationsByUnit,
    } = this.props
    const ids = automationsByUnit[this.unitId()] || []
    const unitAutomation = ids.reduce((obj, key) => ({
      ...obj,
      [key]: automations[key],
    }), { })

    return unitAutomation
  }

  render() {
    return (
      <>
        <PageTitle title="Automation List" />
        <AutomationListView
          automations={this.unitAutomation()}
          unitId={this.unitId()}
          onAdd={this.onAddAutomation}
          onSave={this.onSaveAutomation}
          onDelete={this.onDeleteAutomation}
        />
      </>
    )
  }
}

export default connect(
  UnitAutomationsListPage.mapStateToProps,
  UnitAutomationsListPage.mapDispatchToProps,
)(UnitAutomationsListPage)
